export default __webpack_public_path__ + "static/media/bin-gray.42d7e188.svg";